import React from 'react';
import { Box, Stack } from '@mui/material';
import logo from '../../assets/images/service-lane-eAdvisor-logo.png'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import theme from 'assets/theme'

export default function SunsetView() {
    return (
        <Box style={{
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#595959',
            flexDirection: 'column'
        }}>
            <Stack sx={{ width: '250px', gap: '20px', '& > *': { margin: 0 }, textAlign: 'justify'}}>
                <PowerSettingsNewIcon sx={{ fontSize: '30px' }} />
                <h3>ESS has been discontinued</h3>
                <p>If you have any questions or need assistance, please contact your Service Lane eAdvisor representative or our Customer Support team.</p>
                <div>
                    <div><span style={{ fontWeight: 'bold', color: theme.palette.secondary.main }}>Email:</span> support@sleadvisor.com</div>
                    <div><span style={{ fontWeight: 'bold', color: theme.palette.secondary.main }}>Phone:</span> (866) 484-4777</div>
                </div>
                <div><img src={logo} alt={'Service Lane eAdvisor Logo'} style={{ width: '200px' }}></img></div>
            </Stack>
        </Box>
    )
}